/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Real_EstateInputs */

const en_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real Estate`)
};

const es_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienes raíces`)
};

const fr_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immobilier`)
};

const de_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immobilien`)
};

const ja_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不動産`)
};

const zh_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`房地产`)
};

const ar_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقارات`)
};

const id_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real Estat`)
};

const it_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immobiliare`)
};

const ru_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недвижимость`)
};

const pt_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imóveis`)
};

const ko_listing_category_real_estate = /** @type {(inputs: Listing_Category_Real_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부동산`)
};

/**
* | output |
* | --- |
* | "Real Estate" |
*
* @param {Listing_Category_Real_EstateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_real_estate = /** @type {((inputs?: Listing_Category_Real_EstateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Real_EstateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_real_estate(inputs)
	if (locale === "es") return es_listing_category_real_estate(inputs)
	if (locale === "fr") return fr_listing_category_real_estate(inputs)
	if (locale === "de") return de_listing_category_real_estate(inputs)
	if (locale === "ja") return ja_listing_category_real_estate(inputs)
	if (locale === "zh") return zh_listing_category_real_estate(inputs)
	if (locale === "ar") return ar_listing_category_real_estate(inputs)
	if (locale === "id") return id_listing_category_real_estate(inputs)
	if (locale === "it") return it_listing_category_real_estate(inputs)
	if (locale === "ru") return ru_listing_category_real_estate(inputs)
	if (locale === "pt") return pt_listing_category_real_estate(inputs)
	return ko_listing_category_real_estate(inputs)
});